import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PortalRedirect from './pages/PortalRedirect';
import SelectCustomerPage from './pages/SelectCustomerPage';
import { setDocumentTitle } from './lib/documentTitle';

const PortalApp = () => {
  useEffect(() => {
    setDocumentTitle(null);
  }, []);

  return (
    <Routes>
      <Route path="/" element={<PortalRedirect />} />
      <Route path="/velg-kommune" element={<SelectCustomerPage />} />
      <Route path="/login" element={<Navigate to="/velg-kommune" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default PortalApp;
